import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { DataStateChangeEvent, PageChangeEvent, RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';

import { GridCenterService } from '../../services/grid-center.service';

export abstract class BaseGridComponent {

  skip$: Observable<number>;
  rowsPerPage$: Observable<number>;
  selectableSettings: SelectableSettings = {
    enabled: true,
    mode: "single",
    drag: false,
  };
  
  constructor(
    protected gridCenterService: GridCenterService,
    protected identifierName: string
  ) { 
    this.skip$ = gridCenterService.skipRowsNumber$;
    this.rowsPerPage$ = gridCenterService.rowsPerPage$;
  }

  public pageChange(event: PageChangeEvent): void {
    this.rowsPerPage$.pipe(first()).subscribe((rowsPerPage) => {
      this.gridCenterService.setPageNumber(event.skip / rowsPerPage + 1);
    });
    this.gridCenterService.setSkipRows(event.skip);
    this.gridCenterService.setRowsPerPage(event.take);
  }

  public setIdentifier(identifier: string | number): void {
    this.gridCenterService.setIdentifier(identifier);
  }

  public isRowSelected = (e: RowArgs) => {
    let isSelected: boolean;
    this.gridCenterService.identifier$.subscribe(
      (id) => (isSelected = id === e.dataItem[this.identifierName])
    );
    return isSelected;
  };

  abstract searchClick();

  public searchAndResetPagesClick(): void {
    this.gridCenterService.setSkipRows(0);
    this.gridCenterService.setPageNumber(1);
    this.gridCenterService.resetIdentifier();
    this.searchClick();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.searchClick();
  }

  public setFilters<T>(searchFormValues: T) : void {
    this.gridCenterService.searchCriteria$
    .pipe(first())
    .subscribe((value) => {
      this.gridCenterService.setSearchCriteria({
        ...value,
        ...searchFormValues
      });
    });
  }
}
